define([
    'toolkit/b-toolkit/b-toolkit',
    'Cloud/Application/SocialIconsStatistics',
    'blocks-cloud/b-fileinfo/b-fileinfo',
    'toolkit/b-controls-group/b-controls-group',
], function (toolkit, socialIconsStatistics) {
    const { toNDigits } = require('@mail/cross-sizes-utils');
    const icons = require('Cloud/ui/icons');
    const { getCurrentStorage } = require('reactApp/modules/router/router.selectors');
    const { store: reduxStore } = require('reactApp/store');
    const { canCloneWeblink } = require('reactApp/appHelpers/appHelpers');
    const { EStorageType } = require('reactApp/modules/storage/storage.types');
    const { toolbarActions } = require('reactApp/appHelpers/toolbarActions');

    let publicFile;

    return toolkit['b-controls-group'].extend('shoved-public-file', {
        template: 'app',
        templateBlock: 'shoved-public-file',

        inner: true,

        render: function(item) {
            item = item || app.current();
            publicFile = item;

            var buttons = [
                {
                    name: 'download',
                    mods: ['main'],
                    text: 'Скачать',
                    icon: 'toolbar_download',
                },
            ];

            const isAuthorized = app.user?.isAuthorized();
            if (canCloneWeblink(isAuthorized, getCurrentStorage(reduxStore.getState()))) {
                buttons.push({
                    name: 'clone',
                    mods: [],
                    text: 'Сохранить в Облако',
                    icon: 'toolbar_clone',
                });
            }

            var description = toNDigits({bytes: item.size || 0, maxDigitsCount: 3});
            var sizeTitle = description.space + ' ' + description.units;
            var icon = icons.getItemIcon(item);

            var path = item.own && item.home;
            var data = {
                fileInfo: {
                    icon: icon,
                    isVirus: item.virusScan === 'fail',
                    virusScanStatus: item.virusScan,
                    size: sizeTitle,
                    path: path,
                    name: item.name,
                    buttons: buttons,
                },
                isSocialIcons: false,
                socials: (app.social && app.social.list) || [],
            };

            if (item.mtime) {
                data.fileInfo.date = new Date(item.mtime).format('D.M.Y');
            }

            this.setData(data);

            toolkit['b-toolkit'].fn.render.call(this);

            if (path) {
                // костыль для скорости для точки в b-filename
                // тут она нам не нужна
                var el = this.$el.find('.b-filename');
                var name = '/' + item.name.split('/').pop();
                el.find('.b-filename__spacer')[0].innerHTML = el.find('.b-filename__spacer')[0].innerHTML.replace('.' + name, name);
                el.find('.b-filename__padding')[0].innerHTML = name;
                el.find('.b-filename__extension')[0].innerHTML = name;
            }
        },

        onSocial: function(event, ui) {
            var item = app.current() || {}; // легко вернет undefined;

            app.social.publishItem(ui.id, item);

            socialIconsStatistics.send({
                item: item,
                platform: app.browser.getPlatform(),
                storage: app.getStorage(),
                sendKaktam: true,
                isFile: app.isChoosedPublicFile(),
                isShoved: true,
                service: ui.id,
                socialIconsView: 'content',
            });

            socialIconsStatistics.sendGoogleAnalytics({
                isFile: app.isChoosedPublicFile(),
                isShoved: true,
                service: ui.id,
                socialIconsView: 'content',
            });
        },

        onDownload: function() {
            const state = reduxStore.getState();
            const storage = getCurrentStorage(state);

            app.download(publicFile, undefined, undefined, storage === EStorageType.stock ? undefined : storage);
        },

        onClone: function() {
            const state = reduxStore.getState();
            const storage = getCurrentStorage(state);

            toolbarActions.clone({
                id: storage === EStorageType.stock ? publicFile.stockId : publicFile.id,
                destination: '',
                source: 'shoved',
            })
        },
    });
});
